import { getServerDate } from "../utils/storage/date";
import constants from "../constants";
import { IHashMap, IModifiedType } from "../sync/sync.types";
import * as logger from "../utils/logger";

export interface IShipment extends IHashMap<IShipment> {
    id: string;
    dateTime?: string;
    driver?: IIdEntity | string;
    device?: IIdEntity | string;
    activeFrom?: string;
    activeTo?: string;
    shipperName?: string;
    documentNumber?: string;
    commodity?: string;
    version?: string;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    _isTemp?: boolean;
}

export class Shipment implements IShipment {
    id: string;
    dateTime?: string;
    driver?: IIdEntity | string;
    device?: IIdEntity | string;
    activeFrom?: string;
    activeTo?: string;
    shipperName?: string;
    documentNumber?: string;
    commodity?: string;
    version?: string;

    modified?: IModifiedType;
    previousState?: IShipment;
    /* eslint-disable @typescript-eslint/naming-convention */
    _syncCounter?: number;

    _isTemp?: boolean;

    constructor(object?: IShipment) {
        if (object && Object.keys(object).length > 0) {
            this.id = object.id || "";
            this.dateTime = object.dateTime;
            this.driver = object.driver || "NoUserId";
            this.device = object.device;
            this.activeFrom = object.activeFrom;
            this.activeTo = object.activeTo || constants.MAX_DATE.toISOString();
            this.shipperName = object.shipperName;
            this.documentNumber = object.documentNumber;
            this.commodity = object.commodity;
            this.version = object.version;

            this.modified = object.modified;
            this.previousState = object.previousState;
            this._syncCounter = object._syncCounter || 5;

            this._isTemp = object._isTemp || false;

        } else {
            this.id = "";
            this.dateTime = undefined;
            this.driver = { id: "NoUserId" };
            this.device = { id: "NoDeviceId" };
            this.activeFrom = undefined;
            this.activeTo = constants.MAX_DATE.toISOString();
            this.shipperName = undefined;
            this.documentNumber = undefined;
            this.commodity = undefined;
            this.version = undefined;

            this._syncCounter = 5;

            this._isTemp = false;
        }
    }
    /* eslint-enable @typescript-eslint/naming-convention */

    detach() {
        let oneSecondAgo = getServerDate();
        oneSecondAgo.setTime(oneSecondAgo.getTime() - 1);
        this.activeTo = oneSecondAgo.toISOString();

        // Report error if activeTo is lower than activeFrom
        let activeFrom = this.activeFrom;
        if (activeFrom && activeFrom > oneSecondAgo.toISOString()) {
            logger.error(logger.Source.ERROR, `Current date: ${ new Date().toString() }, Detach: ${ JSON.stringify(this) }`);
            throw new Error("TrailerAttachment activeFrom is higher than activeTo");
        }

        return this;

    }
}